// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"7b75f566","116":"820ffedd","161":"8da1b183","223":"e8830955","556":"781c961d","654":"83c57df8","914":"e7299819","915":"bc2aac06"}[chunkId] + ".chunk.css";
};